<template>
  <div class="elBreadcrumb">
    <el-breadcrumb separator=">>">
      <el-breadcrumb-item :to="{ path: item.path }" v-for="(item, index) in pathList" :key="index" v-if="item.meta.title">
        {{ item.meta.title }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
/** @format */

export default {
    name: 'PageNavigater',
    data() {
        return {
            pathList: [],
        };
    },
    mounted() {
        this.pathList = this.getPathList();
    },
    methods: {
        getPathList() {
            if (this.$route.path === '') {
                return [];
            }

            const route = this.$router.getRoutes().find(a => a.path === this.$route.path);
            const pathList = [];
            const putTogether = data => {
                pathList.unshift({ path: data.path, meta: data.meta });
                if (data.parent && data.parent.path !== '/home') {
                    putTogether(data.parent);
                }
            };

            putTogether(route);
            pathList.unshift({ path: '/home', meta: { title: '首页' } });
            const length = pathList.length;
            if (length > 1 && pathList[length - 1].path.endsWith('/info')) {
                if (localStorage.getItem('article_pid')) {
                    pathList.splice(length - 1, 0, {
                        path: pathList[length - 2].path + '?defTabId=' + localStorage.getItem('article_pid'),
                        meta: {
                            title: localStorage.getItem('article_pname'),
                        },
                    });
                }
            }

            return pathList;
        },
    },
};
</script>
<style>
/** @format */

.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PageNavigater.vue